import { Copy, Heading, LazyImage, Typography } from '../Common'
import React from 'react'
import styled from 'styled-components'
import { ContactsPageProps } from './contactsPage.props'
import { useProfile, LocalLabelsProvider } from '@sentecacommerce-theme/lib'
import { ContactForm, StoresMap } from './Components'

export const ContactsPage = (localLabels: ContactsPageProps) => {
  const { isLoading } = useProfile()

  const {
    title,
    contactsTitle,
    contactsContent,
    image,
    imageAlt,
    formTitle,
    formGDPR,
    labels,
  } = localLabels

  return (
    <LocalLabelsProvider<ContactsPageProps> labels={localLabels}>
      <Container>
        <Heading as="h1" data={title} />
        <Flex>
          <Content>
            <SubTitle>{contactsTitle}</SubTitle>
            <List>
              {contactsContent.map(({ content }, i) => {
                return (
                  <ListItem key={`Item__${i}`}>
                    <Copy html={content} />
                  </ListItem>
                )
              })}
            </List>
            <ImageContainer>
              <LazyImage src={image} alt={imageAlt} />
            </ImageContainer>
          </Content>
          <Aside>
            <SubTitle>{formTitle}</SubTitle>
            {!isLoading && <ContactForm {...formGDPR} />}
          </Aside>
        </Flex>
        <DesktopMapContainer>
          <StickyMap>
            <StoresMap />
          </StickyMap>
        </DesktopMapContainer>
      </Container>
    </LocalLabelsProvider>
  )
}

const Container = styled.section.attrs({
  className: 'container',
})``

const SubTitle = styled(Typography).attrs({
  as: 'h2',
  variant: '4',
  color: 'greyTitle',
  className: 'mb-4',
})<any>`
  font-weight: normal;
`

const Flex = styled.div.attrs({
  className: 'row g-5',
})``

const Content = styled.article.attrs({
  className: 'col-12 col-md-6',
})``

const List = styled.ul`
  list-style: none;
`

const ListItem = styled.li`
  margin-bottom: 1rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`

const ImageContainer = styled.figure.attrs({
  className: 'mt-5 pt-4',
})`
  width: 28rem;
`

const Aside = styled.aside.attrs({
  className: 'col-12 col-md-6',
})``

const StickyMap = styled.div`
  position: sticky;
  top: 8rem;
`

const DesktopMapContainer = styled.aside.attrs({
  className: 'mt-5 pt-4',
})``
